import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-warning-modal',
  templateUrl: './custom-warning-modal.component.html',
  styleUrls: ['./custom-warning-modal.component.scss'],
})
export class CustomWarningModalComponent {
  constructor(
    public dialogRef: MatDialogRef<CustomWarningModalComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) {}

  closeModal(result: boolean) {
    this.dialogRef.close(result);
  }
}
